export const URLS = {
    ViewEventLog: "/v2/eventLog",
    CreateCustomer: "/v2/customers",
    DeactivateCustomer: "/v2/deactivateCustomer",
    ActivateCustomer: "/v2/activateCustomer",
    AddAddressToCustomer: "/v2/addAddressToCustomer",
    DeactivateAddress: "/v2/deactivateAddress",
    UpdateAddress: "/v2/updateAddress",
    InvoiceUpload: "/v2/invoiceUpload",
    GetAllPreDefinedValues: "/v2/predefinedValues",
    GetCustomerDetailsViewActivity: "/v2/getCustomerDetailsViewActivity/",
    GetS3PresignedURL: "https://qm2wrppiv2.execute-api.us-east-1.amazonaws.com/prod/PresignedPOSTS3",
    GetAllBusinessChannelsAndMarketplaces: "/v2/businessChannelAndMarketplaces",
    GetCimarronPersistedInformationGamma: "/v2/cimarronPersistedInformation/",
    GetCimarronPersistedInformationBeta: "/v2/cimarronPersistedInformation/",
    GetCimarronPersistedInformationProd: "/v2/cimarronPersistedInformation/",
    GetUserPermission: "/v2/userPermissionSet",
    UpdateCustomer: "/v2/updateCustomer",
    UpdatePrimaryAddress: "/v2/updatePrimaryAddress",
    GetMigrationEntityList: "/v2/getMigrationEntityList",
    SubmitInvoice: "/v2/submitInvoice",
    PrintInvoice: "/v2/printInvoice",
}
